/**
 * RemixIcon 選單圖示唯一來源。
 * 清單由 Remix Icon v3.5.0 CSS 抽出（與 Admin index.html CDN 同一版），
 * 僅收 line 與沒有 line/fill 成對的 Editor 圖示，避免選到不存在的 class。
 */

export const ICONS_BY_CATEGORY = {
  system: [
    'ri-apps-2-line', 'ri-apps-line', 'ri-dashboard-2-line', 'ri-dashboard-3-line',
    'ri-dashboard-line', 'ri-function-line', 'ri-home-2-line', 'ri-home-3-line',
    'ri-home-4-line', 'ri-home-5-line', 'ri-home-6-line', 'ri-home-7-line',
    'ri-home-8-line', 'ri-home-gear-line', 'ri-home-heart-line', 'ri-home-line',
    'ri-home-office-line', 'ri-home-smile-2-line', 'ri-home-smile-line', 'ri-home-wifi-line',
    'ri-list-settings-line', 'ri-menu-2-line', 'ri-menu-3-line', 'ri-menu-4-line',
    'ri-menu-5-line', 'ri-menu-add-line', 'ri-menu-fold-line', 'ri-menu-line',
    'ri-menu-search-line', 'ri-menu-unfold-line', 'ri-settings-2-line', 'ri-settings-3-line',
    'ri-settings-4-line', 'ri-settings-5-line', 'ri-settings-6-line', 'ri-settings-line',
    'ri-tools-line',
  ],
  user: [
    'ri-account-box-line', 'ri-account-circle-line', 'ri-account-pin-box-line', 'ri-account-pin-circle-line',
    'ri-admin-line', 'ri-aliens-line', 'ri-bear-smile-line', 'ri-body-scan-line',
    'ri-contacts-book-2-line', 'ri-contacts-book-line', 'ri-contacts-book-upload-line', 'ri-contacts-line',
    'ri-criminal-line', 'ri-emoji-sticker-line', 'ri-emotion-2-line', 'ri-emotion-happy-line',
    'ri-emotion-laugh-line', 'ri-emotion-line', 'ri-emotion-normal-line', 'ri-emotion-sad-line',
    'ri-emotion-unhappy-line', 'ri-empathize-line', 'ri-genderless-line', 'ri-ghost-2-line',
    'ri-ghost-line', 'ri-ghost-smile-line', 'ri-group-2-line', 'ri-group-line',
    'ri-heart-2-line', 'ri-heart-3-line', 'ri-heart-add-line', 'ri-heart-line',
    'ri-hearts-line', 'ri-men-line', 'ri-mental-health-line', 'ri-mickey-line',
    'ri-open-arm-line', 'ri-parent-line', 'ri-robot-2-line', 'ri-robot-line',
    'ri-skull-2-line', 'ri-skull-line', 'ri-spy-line', 'ri-star-smile-line',
    'ri-team-line', 'ri-travesti-line', 'ri-user-2-line', 'ri-user-3-line',
    'ri-user-4-line', 'ri-user-5-line', 'ri-user-6-line', 'ri-user-add-line',
    'ri-user-follow-line', 'ri-user-forbid-line', 'ri-user-heart-line', 'ri-user-line',
    'ri-user-location-line', 'ri-user-received-2-line', 'ri-user-received-line', 'ri-user-search-line',
    'ri-user-settings-line', 'ri-user-shared-2-line', 'ri-user-shared-line', 'ri-user-smile-line',
    'ri-user-star-line', 'ri-user-unfollow-line', 'ri-user-voice-line', 'ri-women-line',
  ],
  business: [
    'ri-advertisement-line', 'ri-archive-2-line', 'ri-archive-drawer-line', 'ri-archive-line',
    'ri-at-line', 'ri-auction-line', 'ri-bank-card-2-line', 'ri-bank-card-line',
    'ri-bit-coin-line', 'ri-briefcase-2-line', 'ri-briefcase-3-line', 'ri-briefcase-4-line',
    'ri-briefcase-5-line', 'ri-briefcase-line', 'ri-calculator-line', 'ri-cash-line',
    'ri-cloud-line', 'ri-cloud-off-line', 'ri-coin-line', 'ri-coins-line',
    'ri-copper-coin-line', 'ri-copper-diamond-line', 'ri-copyleft-line', 'ri-copyright-line',
    'ri-coupon-2-line', 'ri-coupon-3-line', 'ri-coupon-4-line', 'ri-coupon-5-line',
    'ri-coupon-line', 'ri-creative-commons-by-line', 'ri-creative-commons-line', 'ri-creative-commons-nc-line',
    'ri-creative-commons-nd-line', 'ri-creative-commons-sa-line', 'ri-creative-commons-zero-line', 'ri-currency-line',
    'ri-exchange-box-line', 'ri-exchange-cny-line', 'ri-exchange-dollar-line', 'ri-exchange-funds-line',
    'ri-exchange-line', 'ri-hand-coin-line', 'ri-hand-heart-line', 'ri-honour-line',
    'ri-inbox-2-line', 'ri-inbox-archive-line', 'ri-inbox-line', 'ri-inbox-unarchive-line',
    'ri-increase-decrease-line', 'ri-instance-line', 'ri-megaphone-line', 'ri-money-cny-box-line',
    'ri-money-cny-circle-line', 'ri-money-dollar-box-line', 'ri-money-dollar-circle-line', 'ri-money-euro-box-line',
    'ri-money-euro-circle-line', 'ri-money-pound-box-line', 'ri-money-pound-circle-line', 'ri-nft-line',
    'ri-p2p-line', 'ri-pass-expired-line', 'ri-pass-pending-line', 'ri-pass-valid-line',
    'ri-percent-line', 'ri-presentation-line', 'ri-price-tag-2-line', 'ri-price-tag-3-line',
    'ri-price-tag-line', 'ri-printer-cloud-line', 'ri-printer-line', 'ri-profile-line',
    'ri-projector-2-line', 'ri-projector-line', 'ri-red-packet-line', 'ri-refund-2-line',
    'ri-refund-line', 'ri-registered-line', 'ri-safe-2-line', 'ri-safe-line',
    'ri-secure-payment-line', 'ri-seo-line', 'ri-service-line', 'ri-shake-hands-line',
    'ri-shopping-bag-2-line', 'ri-shopping-bag-3-line', 'ri-shopping-bag-line', 'ri-shopping-basket-2-line',
    'ri-shopping-basket-line', 'ri-shopping-cart-2-line', 'ri-shopping-cart-line', 'ri-slideshow-2-line',
    'ri-slideshow-3-line', 'ri-slideshow-4-line', 'ri-slideshow-line', 'ri-stack-line',
    'ri-stack-overflow-line', 'ri-stackshare-line', 'ri-store-2-line', 'ri-store-3-line',
    'ri-store-line', 'ri-swap-box-line', 'ri-swap-line', 'ri-ticket-2-line',
    'ri-ticket-line', 'ri-token-swap-line', 'ri-trademark-line', 'ri-wallet-2-line',
    'ri-wallet-3-line', 'ri-wallet-line', 'ri-water-flash-line', 'ri-window-2-line',
    'ri-window-line',
  ],
  vip: [
    'ri-award-line', 'ri-gift-2-line', 'ri-gift-line', 'ri-medal-2-line',
    'ri-medal-line', 'ri-star-half-line', 'ri-star-half-s-line', 'ri-star-line',
    'ri-star-s-line', 'ri-trophy-line', 'ri-vip-crown-2-line', 'ri-vip-crown-line',
    'ri-vip-diamond-line', 'ri-vip-line',
  ],
  file: [
    'ri-article-line', 'ri-bill-line', 'ri-billiards-line', 'ri-book-2-line',
    'ri-book-3-line', 'ri-book-line', 'ri-book-mark-line', 'ri-book-open-line',
    'ri-book-read-line', 'ri-booklet-line', 'ri-bookmark-2-line', 'ri-bookmark-3-line',
    'ri-bookmark-line', 'ri-clipboard-line', 'ri-dossier-line', 'ri-draft-line',
    'ri-file-2-line', 'ri-file-3-line', 'ri-file-4-line', 'ri-file-add-line',
    'ri-file-chart-2-line', 'ri-file-chart-line', 'ri-file-close-line', 'ri-file-cloud-line',
    'ri-file-code-line', 'ri-file-copy-2-line', 'ri-file-copy-line', 'ri-file-damage-line',
    'ri-file-download-line', 'ri-file-edit-line', 'ri-file-excel-2-line', 'ri-file-excel-line',
    'ri-file-forbid-line', 'ri-file-gif-line', 'ri-file-history-line', 'ri-file-hwp-line',
    'ri-file-image-line', 'ri-file-info-line', 'ri-file-line', 'ri-file-list-2-line',
    'ri-file-list-3-line', 'ri-file-list-line', 'ri-file-lock-line', 'ri-file-mark-line',
    'ri-file-music-line', 'ri-file-paper-2-line', 'ri-file-paper-line', 'ri-file-pdf-2-line',
    'ri-file-pdf-line', 'ri-file-ppt-2-line', 'ri-file-ppt-line', 'ri-file-reduce-line',
    'ri-file-search-line', 'ri-file-settings-line', 'ri-file-shield-2-line', 'ri-file-shield-line',
    'ri-file-shred-line', 'ri-file-text-line', 'ri-file-transfer-line', 'ri-file-unknow-line',
    'ri-file-upload-line', 'ri-file-user-line', 'ri-file-video-line', 'ri-file-warning-line',
    'ri-file-word-2-line', 'ri-file-word-line', 'ri-file-zip-line', 'ri-folder-2-line',
    'ri-folder-3-line', 'ri-folder-4-line', 'ri-folder-5-line', 'ri-folder-add-line',
    'ri-folder-chart-2-line', 'ri-folder-chart-line', 'ri-folder-download-line', 'ri-folder-forbid-line',
    'ri-folder-history-line', 'ri-folder-image-line', 'ri-folder-info-line', 'ri-folder-keyhole-line',
    'ri-folder-line', 'ri-folder-lock-line', 'ri-folder-music-line', 'ri-folder-open-line',
    'ri-folder-received-line', 'ri-folder-reduce-line', 'ri-folder-settings-line', 'ri-folder-shared-line',
    'ri-folder-shield-2-line', 'ri-folder-shield-line', 'ri-folder-transfer-line', 'ri-folder-unknow-line',
    'ri-folder-upload-line', 'ri-folder-user-line', 'ri-folder-video-line', 'ri-folder-warning-line',
    'ri-folder-zip-line', 'ri-folders-line', 'ri-health-book-line', 'ri-keynote-line',
    'ri-markdown-line', 'ri-newspaper-line', 'ri-numbers-line', 'ri-pages-line',
    'ri-sticky-note-2-line', 'ri-sticky-note-line', 'ri-survey-line', 'ri-task-line',
    'ri-todo-line',
  ],
  action: [
    'ri-add-box-line', 'ri-add-circle-line', 'ri-add-line', 'ri-alert-line',
    'ri-check-double-line', 'ri-check-line', 'ri-checkbox-blank-circle-line', 'ri-checkbox-blank-line',
    'ri-checkbox-circle-line', 'ri-checkbox-indeterminate-line', 'ri-checkbox-line', 'ri-checkbox-multiple-blank-line',
    'ri-checkbox-multiple-line', 'ri-close-circle-line', 'ri-close-line', 'ri-closed-captioning-line',
    'ri-cross-line', 'ri-delete-back-2-line', 'ri-delete-back-line', 'ri-delete-bin-2-line',
    'ri-delete-bin-3-line', 'ri-delete-bin-4-line', 'ri-delete-bin-5-line', 'ri-delete-bin-6-line',
    'ri-delete-bin-7-line', 'ri-delete-bin-line', 'ri-delete-column', 'ri-delete-row',
    'ri-dislike-line', 'ri-divide-line', 'ri-download-2-line', 'ri-download-cloud-2-line',
    'ri-download-cloud-line', 'ri-download-line', 'ri-drag-drop-line', 'ri-drag-move-2-line',
    'ri-drag-move-line', 'ri-draggable', 'ri-edit-2-line', 'ri-edit-box-line',
    'ri-edit-circle-line', 'ri-edit-line', 'ri-equal-line', 'ri-error-warning-line',
    'ri-external-link-line', 'ri-filter-2-line', 'ri-filter-3-line', 'ri-filter-line',
    'ri-filter-off-line', 'ri-find-replace-line', 'ri-flag-2-line', 'ri-flag-line',
    'ri-indeterminate-circle-line', 'ri-infinity-line', 'ri-information-line', 'ri-install-line',
    'ri-loader-2-line', 'ri-loader-3-line', 'ri-loader-4-line', 'ri-loader-5-line',
    'ri-loader-line', 'ri-login-box-line', 'ri-login-circle-line', 'ri-logout-box-line',
    'ri-logout-box-r-line', 'ri-logout-circle-line', 'ri-logout-circle-r-line', 'ri-loop-left-line',
    'ri-loop-right-line', 'ri-more-2-line', 'ri-more-line', 'ri-question-line',
    'ri-question-mark', 'ri-radio-button-line', 'ri-refresh-line', 'ri-restart-line',
    'ri-save-2-line', 'ri-save-3-line', 'ri-save-line', 'ri-search-2-line',
    'ri-search-eye-line', 'ri-search-line', 'ri-send-plane-2-line', 'ri-send-plane-line',
    'ri-share-box-line', 'ri-share-circle-line', 'ri-share-forward-2-line', 'ri-share-forward-box-line',
    'ri-share-forward-line', 'ri-share-line', 'ri-shut-down-line', 'ri-side-bar-line',
    'ri-subtract-line', 'ri-thumb-down-line', 'ri-thumb-up-line', 'ri-toggle-line',
    'ri-uninstall-line', 'ri-upload-2-line', 'ri-upload-cloud-2-line', 'ri-upload-cloud-line',
    'ri-upload-line', 'ri-zoom-in-line', 'ri-zoom-out-line',
  ],
  arrow: [
    'ri-arrow-down-circle-line', 'ri-arrow-down-double-line', 'ri-arrow-down-line', 'ri-arrow-down-s-line',
    'ri-arrow-drop-down-line', 'ri-arrow-drop-left-line', 'ri-arrow-drop-right-line', 'ri-arrow-drop-up-line',
    'ri-arrow-go-back-line', 'ri-arrow-go-forward-line', 'ri-arrow-left-circle-line', 'ri-arrow-left-double-line',
    'ri-arrow-left-down-line', 'ri-arrow-left-line', 'ri-arrow-left-right-line', 'ri-arrow-left-s-line',
    'ri-arrow-left-up-line', 'ri-arrow-right-circle-line', 'ri-arrow-right-double-line', 'ri-arrow-right-down-line',
    'ri-arrow-right-line', 'ri-arrow-right-s-line', 'ri-arrow-right-up-line', 'ri-arrow-turn-back-line',
    'ri-arrow-turn-forward-line', 'ri-arrow-up-circle-line', 'ri-arrow-up-double-line', 'ri-arrow-up-down-line',
    'ri-arrow-up-line', 'ri-arrow-up-s-line', 'ri-contract-left-line', 'ri-contract-left-right-line',
    'ri-contract-right-line', 'ri-contract-up-down-line', 'ri-corner-down-left-line', 'ri-corner-down-right-line',
    'ri-corner-left-down-line', 'ri-corner-left-up-line', 'ri-corner-right-down-line', 'ri-corner-right-up-line',
    'ri-corner-up-left-double-line', 'ri-corner-up-left-line', 'ri-corner-up-right-double-line', 'ri-corner-up-right-line',
    'ri-expand-left-line', 'ri-expand-left-right-line', 'ri-expand-right-line', 'ri-expand-up-down-line',
    'ri-rewind-line', 'ri-rewind-mini-line', 'ri-skip-back-line', 'ri-skip-back-mini-line',
    'ri-skip-down-line', 'ri-skip-forward-line', 'ri-skip-forward-mini-line', 'ri-skip-left-line',
    'ri-skip-right-line', 'ri-skip-up-line', 'ri-speed-line', 'ri-speed-mini-line',
    'ri-speed-up-line',
  ],
  communication: [
    'ri-chat-1-line', 'ri-chat-2-line', 'ri-chat-3-line', 'ri-chat-4-line',
    'ri-chat-check-line', 'ri-chat-delete-line', 'ri-chat-download-line', 'ri-chat-follow-up-line',
    'ri-chat-forward-line', 'ri-chat-heart-line', 'ri-chat-history-line', 'ri-chat-new-line',
    'ri-chat-off-line', 'ri-chat-poll-line', 'ri-chat-private-line', 'ri-chat-quote-line',
    'ri-chat-settings-line', 'ri-chat-smile-2-line', 'ri-chat-smile-3-line', 'ri-chat-smile-line',
    'ri-chat-upload-line', 'ri-chat-voice-line', 'ri-customer-service-2-line', 'ri-customer-service-line',
    'ri-discuss-line', 'ri-feedback-line', 'ri-mail-add-line', 'ri-mail-check-line',
    'ri-mail-close-line', 'ri-mail-download-line', 'ri-mail-forbid-line', 'ri-mail-line',
    'ri-mail-lock-line', 'ri-mail-open-line', 'ri-mail-send-line', 'ri-mail-settings-line',
    'ri-mail-star-line', 'ri-mail-unread-line', 'ri-mail-volume-line', 'ri-message-2-line',
    'ri-message-3-line', 'ri-message-line', 'ri-notification-2-line', 'ri-notification-3-line',
    'ri-notification-4-line', 'ri-notification-badge-line', 'ri-notification-line', 'ri-notification-off-line',
    'ri-phone-camera-line', 'ri-phone-find-line', 'ri-phone-line', 'ri-phone-lock-line',
    'ri-question-answer-line', 'ri-questionnaire-line', 'ri-record-mail-line', 'ri-reply-all-line',
    'ri-reply-line', 'ri-smartphone-line', 'ri-speak-line', 'ri-video-chat-line',
  ],
  datetime: [
    'ri-alarm-line', 'ri-alarm-warning-line', 'ri-calendar-2-line', 'ri-calendar-check-line',
    'ri-calendar-close-line', 'ri-calendar-event-line', 'ri-calendar-line', 'ri-calendar-todo-line',
    'ri-history-line', 'ri-hourglass-2-line', 'ri-hourglass-line', 'ri-memories-line',
    'ri-rest-time-line', 'ri-time-line', 'ri-timer-2-line', 'ri-timer-flash-line',
    'ri-timer-line', 'ri-zzz-line',
  ],
  chart: [
    'ri-bar-chart-2-line', 'ri-bar-chart-box-line', 'ri-bar-chart-grouped-line', 'ri-bar-chart-horizontal-line',
    'ri-bar-chart-line', 'ri-bubble-chart-line', 'ri-database-2-line', 'ri-database-line',
    'ri-donut-chart-line', 'ri-flow-chart', 'ri-funds-box-line', 'ri-funds-line',
    'ri-line-chart-line', 'ri-mind-map', 'ri-node-tree', 'ri-organization-chart',
    'ri-pie-chart-2-line', 'ri-pie-chart-box-line', 'ri-pie-chart-line', 'ri-stock-line',
  ],
  security: [
    'ri-door-lock-box-line', 'ri-door-lock-line', 'ri-eye-2-line', 'ri-eye-close-line',
    'ri-eye-line', 'ri-eye-off-line', 'ri-fingerprint-2-line', 'ri-fingerprint-line',
    'ri-forbid-2-line', 'ri-forbid-line', 'ri-key-2-line', 'ri-key-line',
    'ri-lock-2-line', 'ri-lock-line', 'ri-lock-password-line', 'ri-lock-unlock-line',
    'ri-prohibited-line', 'ri-shield-check-line', 'ri-shield-cross-line', 'ri-shield-flash-line',
    'ri-shield-keyhole-line', 'ri-shield-line', 'ri-shield-star-line', 'ri-shield-user-line',
    'ri-spam-2-line', 'ri-spam-3-line', 'ri-spam-line', 'ri-verified-badge-line',
  ],
  map: [
    'ri-anchor-line', 'ri-barricade-line', 'ri-bike-line', 'ri-bus-2-line',
    'ri-bus-line', 'ri-bus-wifi-line', 'ri-car-line', 'ri-car-washing-line',
    'ri-caravan-line', 'ri-charging-pile-2-line', 'ri-charging-pile-line', 'ri-china-railway-line',
    'ri-compass-2-line', 'ri-compass-3-line', 'ri-compass-4-line', 'ri-compass-discover-line',
    'ri-compass-line', 'ri-cup-line', 'ri-direction-line', 'ri-e-bike-2-line',
    'ri-e-bike-line', 'ri-earth-line', 'ri-flight-land-line', 'ri-flight-takeoff-line',
    'ri-footprint-line', 'ri-gas-station-line', 'ri-global-line', 'ri-globe-line',
    'ri-goblet-line', 'ri-gps-line', 'ri-guide-line', 'ri-hotel-bed-line',
    'ri-lifebuoy-line', 'ri-luggage-cart-line', 'ri-luggage-deposit-line', 'ri-map-2-line',
    'ri-map-line', 'ri-map-pin-2-line', 'ri-map-pin-3-line', 'ri-map-pin-4-line',
    'ri-map-pin-5-line', 'ri-map-pin-add-line', 'ri-map-pin-line', 'ri-map-pin-range-line',
    'ri-map-pin-time-line', 'ri-map-pin-user-line', 'ri-motorbike-line', 'ri-navigation-line',
    'ri-oil-line', 'ri-parking-box-line', 'ri-parking-line', 'ri-passport-line',
    'ri-pin-distance-line', 'ri-plane-line', 'ri-planet-line', 'ri-police-car-line',
    'ri-pushpin-2-line', 'ri-pushpin-line', 'ri-restaurant-2-line', 'ri-restaurant-line',
    'ri-riding-line', 'ri-road-map-line', 'ri-roadster-line', 'ri-rocket-2-line',
    'ri-rocket-line', 'ri-route-line', 'ri-run-line', 'ri-sailboat-line',
    'ri-ship-2-line', 'ri-ship-line', 'ri-signal-tower-line', 'ri-space-ship-line',
    'ri-steering-2-line', 'ri-steering-line', 'ri-subway-line', 'ri-subway-wifi-line',
    'ri-suitcase-2-line', 'ri-suitcase-3-line', 'ri-suitcase-line', 'ri-takeaway-line',
    'ri-taxi-line', 'ri-taxi-wifi-line', 'ri-traffic-light-line', 'ri-train-line',
    'ri-train-wifi-line', 'ri-treasure-map-line', 'ri-truck-line', 'ri-unpin-line',
    'ri-walk-line',
  ],
  media: [
    'ri-4k-line', 'ri-album-line', 'ri-aspect-ratio-line', 'ri-attachment-line',
    'ri-broadcast-line', 'ri-camera-2-line', 'ri-camera-3-line', 'ri-camera-lens-line',
    'ri-camera-line', 'ri-camera-off-line', 'ri-camera-switch-line', 'ri-clapperboard-line',
    'ri-disc-line', 'ri-dv-line', 'ri-dvd-line', 'ri-eject-line',
    'ri-equalizer-line', 'ri-film-line', 'ri-forward-10-line', 'ri-forward-15-line',
    'ri-forward-30-line', 'ri-forward-5-line', 'ri-fullscreen-exit-line', 'ri-fullscreen-line',
    'ri-gallery-line', 'ri-gallery-upload-line', 'ri-hd-line', 'ri-headphone-line',
    'ri-hq-line', 'ri-image-2-line', 'ri-image-add-line', 'ri-image-edit-line',
    'ri-image-line', 'ri-landscape-line', 'ri-live-line', 'ri-mic-2-line',
    'ri-mic-line', 'ri-mic-off-line', 'ri-microscope-line', 'ri-microsoft-line',
    'ri-microsoft-loop-line', 'ri-movie-2-line', 'ri-movie-line', 'ri-music-2-line',
    'ri-music-line', 'ri-mv-line', 'ri-order-play-line', 'ri-pause-circle-line',
    'ri-pause-line', 'ri-pause-mini-line', 'ri-picture-in-picture-2-line', 'ri-picture-in-picture-exit-line',
    'ri-picture-in-picture-line', 'ri-play-circle-line', 'ri-play-line', 'ri-play-list-2-line',
    'ri-play-list-add-line', 'ri-play-list-line', 'ri-play-mini-line', 'ri-playstation-line',
    'ri-polaroid-2-line', 'ri-polaroid-line', 'ri-radio-2-line', 'ri-radio-line',
    'ri-record-circle-line', 'ri-repeat-2-line', 'ri-repeat-line', 'ri-repeat-one-line',
    'ri-replay-10-line', 'ri-replay-15-line', 'ri-replay-30-line', 'ri-replay-5-line',
    'ri-rhythm-line', 'ri-shuffle-line', 'ri-slow-down-line', 'ri-sound-module-line',
    'ri-speaker-2-line', 'ri-speaker-3-line', 'ri-speaker-line', 'ri-stop-circle-line',
    'ri-stop-line', 'ri-stop-mini-line', 'ri-surround-sound-line', 'ri-tape-line',
    'ri-video-add-line', 'ri-video-download-line', 'ri-video-line', 'ri-video-upload-line',
    'ri-vidicon-2-line', 'ri-vidicon-line', 'ri-voiceprint-line', 'ri-volume-down-line',
    'ri-volume-mute-line', 'ri-volume-off-vibrate-line', 'ri-volume-up-line', 'ri-volume-vibrate-line',
    'ri-webcam-line',
  ],
  logos: [
    'ri-alipay-line', 'ri-amazon-line', 'ri-android-line', 'ri-angularjs-line',
    'ri-app-store-line', 'ri-apple-line', 'ri-baidu-line', 'ri-bard-line',
    'ri-behance-line', 'ri-bilibili-line', 'ri-blender-line', 'ri-bootstrap-line',
    'ri-centos-line', 'ri-chrome-line', 'ri-codepen-line', 'ri-copilot-line',
    'ri-coreos-line', 'ri-dingding-line', 'ri-discord-line', 'ri-disqus-line',
    'ri-douban-line', 'ri-dribbble-line', 'ri-drive-line', 'ri-dropbox-line',
    'ri-edge-line', 'ri-edge-new-line', 'ri-evernote-line', 'ri-facebook-box-line',
    'ri-facebook-circle-line', 'ri-facebook-line', 'ri-firefox-line', 'ri-flickr-line',
    'ri-flutter-line', 'ri-gatsby-line', 'ri-github-line', 'ri-gitlab-line',
    'ri-google-line', 'ri-google-play-line', 'ri-honor-of-kings-line', 'ri-ie-line',
    'ri-instagram-line', 'ri-invision-line', 'ri-kakao-talk-line', 'ri-kick-line',
    'ri-line-line', 'ri-linkedin-box-line', 'ri-linkedin-line', 'ri-mastercard-line',
    'ri-mastodon-line', 'ri-medium-line', 'ri-messenger-line', 'ri-meta-line',
    'ri-mini-program-line', 'ri-netease-cloud-music-line', 'ri-netflix-line', 'ri-notion-line',
    'ri-npmjs-line', 'ri-openai-line', 'ri-openbase-line', 'ri-opera-line',
    'ri-patreon-line', 'ri-paypal-line', 'ri-pinterest-line', 'ri-pixelfed-line',
    'ri-product-hunt-line', 'ri-qq-line', 'ri-reactjs-line', 'ri-reddit-line',
    'ri-remixicon-line', 'ri-safari-line', 'ri-skype-line', 'ri-slack-line',
    'ri-snapchat-line', 'ri-soundcloud-line', 'ri-spectrum-line', 'ri-spotify-line',
    'ri-steam-line', 'ri-supabase-line', 'ri-switch-line', 'ri-taobao-line',
    'ri-telegram-line', 'ri-threads-line', 'ri-tiktok-line', 'ri-trello-line',
    'ri-tumblr-line', 'ri-twitch-line', 'ri-twitter-line', 'ri-twitter-x-line',
    'ri-ubuntu-line', 'ri-unsplash-line', 'ri-vimeo-line', 'ri-visa-line',
    'ri-vuejs-line', 'ri-wechat-2-line', 'ri-wechat-channels-line', 'ri-wechat-line',
    'ri-wechat-pay-line', 'ri-weibo-line', 'ri-whatsapp-line', 'ri-windows-line',
    'ri-wordpress-line', 'ri-xbox-line', 'ri-xing-line', 'ri-youtube-line',
    'ri-yuque-line', 'ri-zcool-line', 'ri-zhihu-line',
  ],
  editor: [
    'ri-a-b', 'ri-align-bottom', 'ri-align-center', 'ri-align-justify',
    'ri-align-left', 'ri-align-right', 'ri-align-top', 'ri-align-vertically',
    'ri-asterisk', 'ri-attachment-2', 'ri-bold', 'ri-bring-forward',
    'ri-bring-to-front', 'ri-code-view', 'ri-double-quotes-l', 'ri-double-quotes-r',
    'ri-dropdown-list', 'ri-emphasis', 'ri-emphasis-cn', 'ri-english-input',
    'ri-font-color', 'ri-font-family', 'ri-font-mono', 'ri-font-sans',
    'ri-font-sans-serif', 'ri-font-size', 'ri-font-size-2', 'ri-format-clear',
    'ri-functions', 'ri-h-1', 'ri-h-2', 'ri-h-3',
    'ri-h-4', 'ri-h-5', 'ri-h-6', 'ri-hashtag',
    'ri-heading', 'ri-indent-decrease', 'ri-indent-increase', 'ri-input-cursor-move',
    'ri-input-method-line', 'ri-insert-column-left', 'ri-insert-column-right', 'ri-insert-row-bottom',
    'ri-insert-row-top', 'ri-italic', 'ri-line-height', 'ri-link',
    'ri-link-m', 'ri-link-unlink', 'ri-link-unlink-m', 'ri-links-line',
    'ri-list-check', 'ri-list-check-2', 'ri-list-check-3', 'ri-list-indefinite',
    'ri-list-ordered', 'ri-list-ordered-2', 'ri-list-radio', 'ri-list-unordered',
    'ri-merge-cells-horizontal', 'ri-merge-cells-vertical', 'ri-number-0', 'ri-number-1',
    'ri-number-2', 'ri-number-3', 'ri-number-4', 'ri-number-5',
    'ri-number-6', 'ri-number-7', 'ri-number-8', 'ri-number-9',
    'ri-omega', 'ri-overline', 'ri-page-separator', 'ri-paragraph',
    'ri-pinyin-input', 'ri-quote-text', 'ri-rounded-corner', 'ri-send-backward',
    'ri-send-to-back', 'ri-separator', 'ri-single-quotes-l', 'ri-single-quotes-r',
    'ri-sketching', 'ri-slash-commands', 'ri-slash-commands-2', 'ri-sort-asc',
    'ri-sort-desc', 'ri-space', 'ri-split-cells-horizontal', 'ri-split-cells-vertical',
    'ri-strikethrough', 'ri-strikethrough-2', 'ri-subscript', 'ri-subscript-2',
    'ri-superscript', 'ri-superscript-2', 'ri-table-2', 'ri-text',
    'ri-text-direction-l', 'ri-text-direction-r', 'ri-text-spacing', 'ri-text-wrap',
    'ri-translate', 'ri-translate-2', 'ri-underline', 'ri-wubi-input',
  ],
  device: [
    'ri-airplay-line', 'ri-barcode-box-line', 'ri-barcode-line', 'ri-base-station-line',
    'ri-battery-2-charge-line', 'ri-battery-2-line', 'ri-battery-charge-line', 'ri-battery-line',
    'ri-battery-low-line', 'ri-battery-saver-line', 'ri-battery-share-line', 'ri-bluetooth-connect-line',
    'ri-bluetooth-line', 'ri-cast-line', 'ri-cellphone-line', 'ri-computer-line',
    'ri-cpu-line', 'ri-device-line', 'ri-device-recover-line', 'ri-dual-sim-1-line',
    'ri-dual-sim-2-line', 'ri-gamepad-line', 'ri-gradienter-line', 'ri-hard-drive-2-line',
    'ri-hard-drive-3-line', 'ri-hard-drive-line', 'ri-hotspot-line', 'ri-keyboard-box-line',
    'ri-keyboard-line', 'ri-mac-line', 'ri-macbook-line', 'ri-mouse-line',
    'ri-outlet-2-line', 'ri-outlet-line', 'ri-plug-2-line', 'ri-plug-line',
    'ri-qr-code-line', 'ri-qr-scan-2-line', 'ri-qr-scan-line', 'ri-radar-line',
    'ri-remote-control-2-line', 'ri-remote-control-line', 'ri-rfid-line', 'ri-rotate-lock-line',
    'ri-router-line', 'ri-rss-line', 'ri-scan-2-line', 'ri-scan-line',
    'ri-sd-card-line', 'ri-sd-card-mini-line', 'ri-sensor-line', 'ri-server-line',
    'ri-signal-wifi-1-line', 'ri-signal-wifi-2-line', 'ri-signal-wifi-3-line', 'ri-signal-wifi-error-line',
    'ri-signal-wifi-line', 'ri-signal-wifi-off-line', 'ri-sim-card-2-line', 'ri-sim-card-line',
    'ri-tablet-line', 'ri-tv-2-line', 'ri-tv-line', 'ri-u-disk-line',
    'ri-usb-line', 'ri-wifi-line', 'ri-wifi-off-line', 'ri-wireless-charging-line',
  ],
  design: [
    'ri-anticlockwise-2-line', 'ri-anticlockwise-line', 'ri-artboard-2-line', 'ri-artboard-line',
    'ri-ball-pen-line', 'ri-blur-off-line', 'ri-brush-2-line', 'ri-brush-3-line',
    'ri-brush-4-line', 'ri-brush-line', 'ri-circle-line', 'ri-clockwise-2-line',
    'ri-clockwise-line', 'ri-collage-line', 'ri-compasses-2-line', 'ri-compasses-line',
    'ri-contrast-2-line', 'ri-contrast-drop-2-line', 'ri-contrast-drop-line', 'ri-contrast-line',
    'ri-crop-2-line', 'ri-crop-line', 'ri-crosshair-2-line', 'ri-crosshair-line',
    'ri-drop-line', 'ri-eraser-line', 'ri-focus-2-line', 'ri-focus-3-line',
    'ri-focus-line', 'ri-grid-line', 'ri-hammer-line', 'ri-hexagon-line',
    'ri-ink-bottle-line', 'ri-layout-2-line', 'ri-layout-3-line', 'ri-layout-4-line',
    'ri-layout-5-line', 'ri-layout-6-line', 'ri-layout-bottom-2-line', 'ri-layout-bottom-line',
    'ri-layout-column-line', 'ri-layout-grid-line', 'ri-layout-left-2-line', 'ri-layout-left-line',
    'ri-layout-line', 'ri-layout-masonry-line', 'ri-layout-right-2-line', 'ri-layout-right-line',
    'ri-layout-row-line', 'ri-layout-top-2-line', 'ri-layout-top-line', 'ri-magic-line',
    'ri-mark-pen-line', 'ri-markup-line', 'ri-octagon-line', 'ri-paint-brush-line',
    'ri-paint-line', 'ri-palette-line', 'ri-pantone-line', 'ri-pen-nib-line',
    'ri-pencil-line', 'ri-pencil-ruler-2-line', 'ri-pencil-ruler-line', 'ri-pentagon-line',
    'ri-quill-pen-line', 'ri-rectangle-line', 'ri-ruler-2-line', 'ri-ruler-line',
    'ri-scissors-2-line', 'ri-scissors-cut-line', 'ri-scissors-line', 'ri-screenshot-2-line',
    'ri-screenshot-line', 'ri-shape-2-line', 'ri-shape-line', 'ri-shapes-line',
    'ri-sip-line', 'ri-slice-line', 'ri-square-line', 'ri-t-box-line',
    'ri-table-alt-line', 'ri-table-line', 'ri-triangle-line',
  ],
  development: [
    'ri-braces-line', 'ri-brackets-line', 'ri-bug-2-line', 'ri-bug-line',
    'ri-code-box-line', 'ri-code-line', 'ri-code-s-line', 'ri-code-s-slash-line',
    'ri-command-line', 'ri-css3-line', 'ri-cursor-line', 'ri-git-branch-line',
    'ri-git-close-pull-request-line', 'ri-git-commit-line', 'ri-git-merge-line', 'ri-git-pull-request-line',
    'ri-git-repository-commits-line', 'ri-git-repository-line', 'ri-git-repository-private-line', 'ri-html5-line',
    'ri-javascript-line', 'ri-open-source-line', 'ri-parentheses-line', 'ri-terminal-box-line',
    'ri-terminal-line', 'ri-terminal-window-line',
  ],
  buildings: [
    'ri-ancient-gate-line', 'ri-ancient-pavilion-line', 'ri-bank-line', 'ri-building-2-line',
    'ri-building-3-line', 'ri-building-4-line', 'ri-building-line', 'ri-community-line',
    'ri-door-closed-line', 'ri-door-line', 'ri-door-open-line', 'ri-government-line',
    'ri-hospital-line', 'ri-hotel-line', 'ri-school-line', 'ri-tent-line',
  ],
  weather: [
    'ri-blaze-line', 'ri-cactus-line', 'ri-celsius-line', 'ri-cloud-windy-line',
    'ri-cloudy-2-line', 'ri-cloudy-line', 'ri-drizzle-line', 'ri-earthquake-line',
    'ri-fahrenheit-line', 'ri-fire-line', 'ri-flashlight-line', 'ri-flood-line',
    'ri-foggy-line', 'ri-hail-line', 'ri-haze-2-line', 'ri-haze-line',
    'ri-heavy-showers-line', 'ri-leaf-line', 'ri-meteor-line', 'ri-mist-line',
    'ri-moon-clear-line', 'ri-moon-cloudy-line', 'ri-moon-foggy-line', 'ri-moon-line',
    'ri-plant-line', 'ri-rainbow-line', 'ri-rainy-line', 'ri-recycle-line',
    'ri-seedling-line', 'ri-showers-line', 'ri-snowy-line', 'ri-sun-cloudy-line',
    'ri-sun-foggy-line', 'ri-sun-line', 'ri-temp-cold-line', 'ri-temp-hot-line',
    'ri-thunderstorms-line', 'ri-tornado-line', 'ri-tree-line', 'ri-typhoon-line',
    'ri-umbrella-line', 'ri-water-percent-line', 'ri-windy-line',
  ],
  other: [
    'ri-24-hours-line', 'ri-ai-generate', 'ri-basketball-line', 'ri-beer-line',
    'ri-bell-line', 'ri-box-1-line', 'ri-box-2-line', 'ri-box-3-line',
    'ri-boxing-line', 'ri-brain-line', 'ri-cake-2-line', 'ri-cake-3-line',
    'ri-cake-line', 'ri-candle-line', 'ri-capsule-line', 'ri-character-recognition-line',
    'ri-finder-line', 'ri-first-aid-kit-line', 'ri-flask-line', 'ri-football-line',
    'ri-fridge-line', 'ri-game-line', 'ri-graduation-cap-line', 'ri-hand-sanitizer-line',
    'ri-handbag-line', 'ri-heart-pulse-line', 'ri-infrared-thermometer-line', 'ri-knife-blood-line',
    'ri-knife-line', 'ri-lightbulb-flash-line', 'ri-lightbulb-line', 'ri-lungs-line',
    'ri-medicine-bottle-line', 'ri-nurse-line', 'ri-ping-pong-line', 'ri-psychotherapy-line',
    'ri-pulse-line', 'ri-reserved-line', 'ri-scales-2-line', 'ri-scales-3-line',
    'ri-scales-line', 'ri-shining-2-line', 'ri-shining-line', 'ri-shirt-line',
    'ri-sparkling-2-line', 'ri-sparkling-line', 'ri-stethoscope-line', 'ri-surgical-mask-line',
    'ri-sword-line', 'ri-syringe-line', 'ri-t-shirt-2-line', 'ri-t-shirt-air-line',
    'ri-t-shirt-line', 'ri-test-tube-line', 'ri-thermometer-line', 'ri-virus-line',
    'ri-voice-recognition-line', 'ri-wheelchair-line',
  ],
};

export const ICON_CATEGORY_META = [
  { key: 'all', label: '全部', icon: 'ri-apps-line' },
  { key: 'system', label: '系統', icon: 'ri-settings-line' },
  { key: 'user', label: '用戶', icon: 'ri-user-line' },
  { key: 'business', label: '商業', icon: 'ri-briefcase-line' },
  { key: 'vip', label: 'VIP', icon: 'ri-vip-crown-line' },
  { key: 'file', label: '文件', icon: 'ri-folder-line' },
  { key: 'action', label: '操作', icon: 'ri-edit-line' },
  { key: 'arrow', label: '箭頭', icon: 'ri-arrow-right-line' },
  { key: 'communication', label: '通訊', icon: 'ri-message-line' },
  { key: 'datetime', label: '日期', icon: 'ri-calendar-line' },
  { key: 'chart', label: '統計', icon: 'ri-bar-chart-line' },
  { key: 'security', label: '安全', icon: 'ri-shield-line' },
  { key: 'map', label: '地圖', icon: 'ri-map-pin-line' },
  { key: 'media', label: '媒體', icon: 'ri-image-line' },
  { key: 'logos', label: '社群', icon: 'ri-wechat-line' },
  { key: 'editor', label: '編輯', icon: 'ri-bold' },
  { key: 'device', label: '裝置', icon: 'ri-computer-line' },
  { key: 'design', label: '設計', icon: 'ri-palette-line' },
  { key: 'development', label: '開發', icon: 'ri-code-line' },
  { key: 'buildings', label: '場所', icon: 'ri-building-line' },
  { key: 'weather', label: '天氣', icon: 'ri-sun-line' },
  { key: 'other', label: '其他', icon: 'ri-more-line' },
];

export function iconClassToDisplayName(iconClass) {
  return iconClass.replace(/^ri-/, '').replace(/-line$/, '');
}

export function getAllIconClasses() {
  return Object.values(ICONS_BY_CATEGORY).flat();
}

export function getIconsByCategoryKey(categoryKey) {
  if (!categoryKey || categoryKey === 'all') {
    return getAllIconClasses();
  }
  return ICONS_BY_CATEGORY[categoryKey] || [];
}

export function getCatalogIconEntries() {
  return Object.entries(ICONS_BY_CATEGORY).flatMap(([category, icons]) =>
    icons.map((name) => ({
      name,
      category,
      displayName: iconClassToDisplayName(name),
    }))
  );
}

export function getIconCategoryFilters() {
  const allCount = getAllIconClasses().length;
  return ICON_CATEGORY_META.map((meta) => ({
    ...meta,
    count: meta.key === 'all'
      ? allCount
      : (ICONS_BY_CATEGORY[meta.key] || []).length,
  }));
}
